import React from "react";
import { useAuth } from "../context/AuthContext";

const ADMIN_NAV = [
  { section: "Overview" },
  { id: "dashboard",   label: "Dashboard",  icon: "📊" },
  { section: "Tasks" },
  { id: "all-tasks",   label: "All Tasks",  icon: "📋" },
  { id: "pending",     label: "Pending",    icon: "⏳" },
  { id: "completed",   label: "Completed",  icon: "✅" },
  { id: "overdue",     label: "Overdue",    icon: "🔴" },
  { id: "monitor",     label: "Monitor",    icon: "👁️" },
  { section: "Actions" },
  { id: "create-task", label: "Create Task",icon: "✨" },
  { section: "People" },
  { id: "users",       label: "Employees",  icon: "👥" },
];

const EMPLOYEE_NAV = [
  { section: "Overview" },
  { id: "dashboard",   label: "Dashboard",     icon: "📊" },
  { section: "My Tasks" },
  { id: "all-tasks",   label: "All Tasks",     icon: "📋" },
  { id: "pending",     label: "Pending",       icon: "⏳" },
  { id: "completed",   label: "Completed",     icon: "✅" },
  { id: "overdue",     label: "Overdue",       icon: "🔴" },
  { section: "Activity" },
  { id: "created",     label: "Created Tasks", icon: "📝" },
  { id: "monitor",     label: "Monitor",       icon: "👁️" },
  { section: "Actions" },
  { id: "create-task", label: "Create Task",   icon: "✨" },
];

export default function Sidebar({ activePage, onNavigate, isOpen, onClose }) {
  const { user, logout } = useAuth();
  const nav = user?.role === "admin" ? ADMIN_NAV : EMPLOYEE_NAV;

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? "visible" : ""}`} onClick={onClose} />
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-logo">
          <div className="sidebar-logo-inner">
            <div className="logo-icon">🗂️</div>
            <div>
              <h2>Task</h2>
              <p>{user?.role === "admin" ? "Admin Panel" : "Employee Panel"}</p>
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {nav.map((item, i) => {
            if (item.section) return <div key={i} className="nav-section-title">{item.section}</div>;
            return (
              <div key={item.id}
                className={`nav-item ${activePage === item.id ? "active" : ""}`}
                onClick={() => { onNavigate(item.id); onClose?.(); }}
              >
                <span className="nav-icon">{item.icon}</span>
                {item.label}
              </div>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="user-chip" onClick={logout} title="Click to logout">
            <div className={`avatar avatar-sm avatar-${user?.role}`}>
              {user?.initials || user?.name?.[0]?.toUpperCase()}
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:13, fontWeight:600, color:"white", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                {user?.name}
              </div>
              <div style={{ fontSize:10, color:"var(--gray-500)", textTransform:"capitalize" }}>
                {user?.role} · Tap to logout
              </div>
            </div>
            <span style={{ fontSize:14, color:"var(--gray-600)" }}>🚪</span>
          </div>
        </div>
      </div>
    </>
  );
}
